import { toast } from "react-toastify";
import { fetchDeletePolicySuccess, fetchDeletePolicyFailure } from "./reducer";
import api, { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { CREATE_POLICY_API } from "../../constants/constants";
import { getAllPolicies } from "../../PartnerMangement/policylist/thunk";

export const deletePolicy = (policyId, setLoading) => async (dispatch) => {
    setLoading(true)
    await determineBaseUrlAndPerformApiCall(`${CREATE_POLICY_API}/${policyId}`, 'DELETE').then((response) => {
        if (response.error) {
            dispatch(fetchDeletePolicyFailure(response.error.message))
            setLoading(false)
            toast.error(`${response.error.message}`)
        }
        if (!response.error) {
            dispatch(fetchDeletePolicySuccess(response))
            setLoading(false)
            toast.success(`${policyId} policy Deleted Successfully`)
            dispatch(getAllPolicies(setLoading))
        }
    }).catch((errorResp) => { })
}